import { Directive, HostListener, forwardRef, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[convertToNumber]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConvertToNumberDirective),
      multi: true
    }
  ]
})
export class ConvertToNumberDirective implements ControlValueAccessor {

  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef<HTMLSelectElement | HTMLInputElement>) {}

  writeValue(value: number | null): void {
    const nativeEl = this.el.nativeElement;

    nativeEl.value = value === null || value === undefined
      ? ''
      : String(value);
  }

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('change', ['$event'])
  handleChange(event: Event): void {
    const target = event.target as HTMLSelectElement | HTMLInputElement | null;

    if (!target) {
      this.onChange(null);
      return;
    }

    const value = target.value;
    const parsed = value === '' ? null : Number(value);

    this.onChange(Number.isNaN(parsed) ? null : parsed);
  }

  @HostListener('blur')
  handleBlur(): void {
    this.onTouched();
  }
}
